<template>
  <div class="modal order-modal">
    <div class="overlay" @click="$parent.closeOrderModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$parent.closeOrderModal" src="./../images/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="modal-top">
                  <div class="back-link" @click="$parent.openTopUpModal">
                    <img class="back" src="./../images/back.svg" />{{ $t(`Back`) }}</div>
                  <div class="title medium">{{ $t(`Payment details`) }}</div>
                </div>
                <div class="fields">
                  <label>
                    <span class="desc">{{ $t(`First name:`) }}</span>
                    <input type="text" v-model="name" :placeholder="$t('Your first name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`Last name:`) }}</span>
                    <input type="text" v-model="surname" :placeholder="$t('Your last name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`Phone:`) }}</span>
                    <input type="text" v-model="phone" @input="allowOnlyNumbers" :placeholder="$t('Your phone number')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`Email:`) }}</span>
                    <input type="email" v-model="email" :placeholder="$t('Your email')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`Address:`) }}</span>
                    <input type="text" v-model="address" :placeholder="$t('Your address')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`City:`) }}</span>
                    <input type="text" v-model="city" :placeholder="$t('Your city')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`Country:`) }}</span>
                    <select v-model="country">
                      <option value="" disabled selected>{{ $t(`Your county`) }}</option>
                      <option v-for="item in countryOptions" :value="item.id" :key="item.title">{{item.title}}</option>
                    </select>
                  </label>
                  <label>
                    <span class="desc">{{ $t(`ZIP Code:`) }}</span>
                    <input type="text" v-model="postCode" :placeholder="$t('Your zip code')"/>
                  </label>
                </div>
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input 
                        v-model="terms"
                        type="checkbox" 
                        name="terms" 
                      >
                      <div class="checkbox" />
                      <span class="desc">{{ $t('I agree with') }} </span>
                      <a 
                        class="desc orange"
                        @click="$parent.goToPage('privacy')"
                      >{{ $t('privacy policy') }}</a>
                      <span class="desc"> {{ $t('and') }} </span>
                      <a 
                        class="desc orange"
                        @click="$parent.goToPage('terms')"
                      >{{ $t('terms and conditions') }}</a>
                    </div>
                  </label>
                </div>
                <div class="modal-bottom">
                  <div class="text">
                    <span class="title medium">{{ $t('You get:') }}</span>
                    <span class="title medium">
                      {{ creditsAmount }}
                      <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                      ({{ $parent.topUpAmount }} {{ $parent.currencyCode }})
                    </span>
                  </div>
                  <div class="button-wrapper" v-if="paymentMethods.length">
                    <div
                      v-for="method in paymentMethods"
                      :key="method.code"
                      :class="['button', method.code === 'applepay' ? 'apple-pay' : method.code === 'googlepay' ? 'google-pay' : '', {'disabled': !requiredFieldsAreFilled}]"
                      @click="submit(method.code)"
                    >
                      <img v-if="method.image && method.code !== 'card'" :src="method.image" :alt="method.title" />
                      <template v-else>{{ $t('Pay') }}</template>
                    </div>
                  </div>
                  <div class="button-wrapper" v-else>
                    <div :class="['button apple-pay', {'disabled': !requiredFieldsAreFilled}]" @click="submit('applepay')">
                        <img alt="appleplay image" class="" src="../images/apple-pay.svg" />
                    </div>
                    <div :class="['button google-pay', {'disabled': !requiredFieldsAreFilled}]" @click="submit('googlepay')">
                        <img alt="googlepay image" class="" src="../images/google-pay.svg" />
                    </div>
                    <div :class="['button', {'disabled': !requiredFieldsAreFilled}]" @click="submit('card')">{{ $t('Pay') }}</div>
                  </div>
                </div>
                <transition name="fade">
                  <div class="desc error" v-if="$parent.error">{{ $parent.error }}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderModal",
  props: ['currency', 'paymentMethods'],
  components: {},
  data: function () {
    return {
      amount: 5,
      countryOptions: [],
      name: '',
      surname: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      country: '',
      postCode: '',
      terms: ''
    };
  },
  computed: {
    creditsAmount() {
      const amount = parseFloat(this.$parent.topUpAmount);
      const currencyValue = parseFloat(this.$parent.currencyValue);
      
      if (!isNaN(amount) && !isNaN(currencyValue) && amount > 0 && currencyValue > 0) {
        return (amount / currencyValue).toFixed(2);
      }
      return '0';
    },
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname && this.phone && 
        this.email && this.country && 
        this.city && this.address && this.terms
        && this.postCode 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  mounted() {
    this.getProfile();
    this.getCounties();
  },
  methods: {
    allowOnlyNumbers(){
      this.phone = this.phone.replace(/[^0-9.,]/g, '');
      const parts = this.phone.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.phone = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    },
    submit(payType) {
      let amount = this.$parent.topUpAmount;
      let data = {
        "first_name": this.name,
        "last_name": this.surname,
        "phone": this.phone,
        "email": this.email,
        "country_id": this.country,
        "city": this.city,
        "address": this.address,
        "zip": this.postCode,
        "amount": amount,
        "paymentType": payType,
        "currency": this.$parent.currencyCode
      }
      this.$emit('topUp', data)
    },
    getProfile() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
          this.countryOptions = res.data.payload;
         
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    toCheckout() {
      this.$parent.closeTopUpModal();
    },
  },
};
</script>
